export default __webpack_public_path__ + "static/media/cabourg2.123c8222.jpg";